import { CustomTheme } from '../../theme/customTheme';

type Props = Readonly<{
  size?: number;
  color?: string;
}>;

function SleepIcon({ size = 50, color = CustomTheme.colors.contentPrimary }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      height={size}
      width={size}
    >
      <path
        d="M5 18.5h6l-6-5.5h6"
        fill={color}
      />
      <path
        d="M11.5 9h5.5l-5.5 5h5.5"
        fill={color}
      />
      <path
        d="M15 4h4l-4 3.5h4"
        fill={color}
      />
    </svg>
  );
}

export default SleepIcon;
